import type { IconSvgObject } from './types';

const CircleArrowRightDoubleIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.9154 15C12.9154 15 15.5 12.7905 15.5 12C15.5 11.2094 12.9154 9 12.9154 9M8.50002 15C8.50002 15 11.0846 12.7905 11.0846 12C11.0846 11.2094 8.5 9 8.5 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowRightDoubleIcon;
